import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faChartPie,
  faChartBar,
  faCalendarAlt,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";

const AnalyticsPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <span className="text-4xl">📊</span>
        <h1 className="text-3xl font-bold">Advanced Analytics</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <img
            src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1115&q=80"
            alt="Analytics dashboard"
            className="rounded-lg shadow-md w-full h-64 object-cover"
          />

          <div className="mt-6 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h2 className="text-xl font-semibold mb-4">Subscription Plan</h2>
            <div className="space-y-4">
              <div className="flex justify-between">
                <span className="font-medium">Reports Included</span>
                <span>15+ metrics</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Data Retention</span>
                <span>24 months</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Export Formats</span>
                <span>PDF, CSV, Excel</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Price</span>
                <span className="font-bold">12,000 MMK/month</span>
              </div>
            </div>

            <button className="mt-6 w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
              Enable Analytics
            </button>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Key Metrics</h2>

          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <FontAwesomeIcon icon={faChartLine} className="text-blue-500" />
                <h3 className="font-medium">Sales Trends</h3>
              </div>
              <p className="text-sm text-gray-600">
                Daily, weekly, and monthly sales patterns
              </p>
            </div>

            <div className="bg-green-50 p-4 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <FontAwesomeIcon icon={faChartPie} className="text-green-500" />
                <h3 className="font-medium">Product Mix</h3>
              </div>
              <p className="text-sm text-gray-600">
                Best sellers and category performance
              </p>
            </div>

            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <FontAwesomeIcon
                  icon={faChartBar}
                  className="text-purple-500"
                />
                <h3 className="font-medium">Customer Behavior</h3>
              </div>
              <p className="text-sm text-gray-600">
                Purchase frequency and average spend
              </p>
            </div>

            <div className="bg-orange-50 p-4 rounded-lg">
              <div className="flex items-center gap-3 mb-2">
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  className="text-orange-500"
                />
                <h3 className="font-medium">Seasonal Trends</h3>
              </div>
              <p className="text-sm text-gray-600">
                Holiday and special event impacts
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h3 className="font-semibold mb-4">Sample Dashboard</h3>
            <img
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
              alt="Analytics dashboard"
              className="rounded-lg w-full h-48 object-cover"
            />

            <div className="mt-4 flex items-center gap-3">
              <FontAwesomeIcon icon={faFilter} className="text-gray-500" />
              <span className="text-sm text-gray-600">
                Filter by date range, location, product category
              </span>
            </div>
          </div>

          <div className="mt-6">
            <h3 className="font-semibold mb-3">Export Options</h3>
            <div className="flex gap-3">
              <button className="px-4 py-2 border rounded-lg text-sm font-medium">
                PDF Report
              </button>
              <button className="px-4 py-2 border rounded-lg text-sm font-medium">
                CSV Data
              </button>
              <button className="px-4 py-2 border rounded-lg text-sm font-medium">
                Excel Sheet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage;
